export default __webpack_public_path__ + "static/media/f_news.7517245f.svg";